/*
*###############################################################################
*Module Name                   : InboundCapacityMaster.js                      #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath                                 #
*Date                          : Friday, December 01th 2021, 08:35:19 am       #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import InboundCapacityContent from './InboundCapacityContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { DeleteInboundCapacityDetails, InboundCapacityDetailsGetData, SaveInboundCapacityDetails } from './InboundCapacityController'
import { func } from 'prop-types'

//**End Importing required componant files */

const InboundCapacityMaster = (props) => {

    let history = useHistory();
    //Values from designation context
    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
    } = useContext(Context);


    //*** User input related states */

    const [code, SetCode] = useState("");// Set Code
    const [strDepartment, SetStrDepartment] = useState("");// Set Department
    const [departmentName, SetDepartmentName] = useState("")//Set Department Name
    const [strYear, SetStrYear] = useState("")//Set Year
    const [strWeek, SetStrWeek] = useState("")//Set Week
    const [strMinCap, SetStrMinCap] = useState("")//Set Min capacity
    const [strMaxCap, SetStrMaxCap] = useState("")//Set Max capacity

    const [menuCode, SetMenuCode] = useState("")
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [code_modal_xlarge, setcode_modal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)
    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    //import from contexts
    var time = process.env.REACT_APP_ALERTTIMEOUT

    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]

        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName

        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)


        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)

        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

    }, [code])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])


    async function getDepartmentData(departmentCode) {

        const response = await fetch(`${ApiURL}group/${1}/${departmentCode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        });

        const result = await response.json();

        if (result.success && result.data.GP_CODE != null) {
            SetStrDepartment(result.data.GP_CODE);
            SetDepartmentName(result.data.GP_DESC);
        } else {
            displayAlertMessage("danger", "Invalid group code");
            SetStrDepartment("");
        }

    }


    async function getData(searchData) {
        if (searchData == "") return;

        SetLoadingAlert(true);
        SetLoadingAlerttitle("Fetching...");

        const inboundResult = await InboundCapacityDetailsGetData(searchData);
        SetLoadingAlert(false);

        if (inboundResult.success == true) {

            SetCode(inboundResult.data.cmCode);
            SetStrDepartment(inboundResult.data.cmGrpId);
            getDepartmentData(inboundResult.data.cmGrpId)
            SetStrYear(inboundResult.data.cmYear);
            SetStrWeek(inboundResult.data.cmWeek);
            SetStrMinCap(inboundResult.data.cmMin);
            SetStrMaxCap(inboundResult.data.cmMax);
            setCrBy(inboundResult.data.createdBy);
            setCrDate(inboundResult.data.createdDate);
            setMdBy(inboundResult.data.modifiedBy);
            setMdDate(inboundResult.data.modifiedDate == "1900-01-01T00:00:00" ? "" : inboundResult.data.modifiedDate)
            setCrEnable(true);

            setDisabled(true);
            setDisabledCode(true);
            setSaveEnable(false);
            SetAddNew(false);
            SetDeleteEnable(true);
            setSearchdisabled(true);
            setReason("Updated");
            SetEditEnable(true);

        }
        // else {
        //     displayAlertMessage("danger", "Invalid group code");
        //     SetStrDepartment("");
        // }


    }

    // *** End useEffect */

    // print Function
    async function handlePrint(option) {
        var option = option
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/designation/report/${LogUserType}/${option == "PDF" ? 1 : 0}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }

                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    function code_tog_xlarge() {
        setcode_modal_xlarge(!code_modal_xlarge)
        removeBodyCss()
    }


    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }



    //save button function
    const handlesave = async (e) => {

        const urrentCode = addNew == true && nullCode == false ? autoCode : code

        if (urrentCode == "") {
            displayAlertMessage("danger", "Please Enter Code !")
            return;
        }

        if (strDepartment == "") {
            displayAlertMessage("danger", "Please Enter Department Code !")
            return;
        }

        if (strYear == "") {
            displayAlertMessage('danger', "Please Enter Year")
            return;
        }
        if (strWeek == "") {
            displayAlertMessage('danger', "Please Enter Week")
            return;
        }
        if (strMinCap === "") {
            displayAlertMessage('danger', "Please Enter Min capacity")
            return;
        }
        if (strMaxCap === "") {
            displayAlertMessage('danger', "Please Enter Max capacity")
            return;
        }

        const InboundCapacity = {
            "cmCode": urrentCode,
            "cmGrpId": strDepartment,
            "cmYear": parseFloat(strYear),
            "cmWeek": parseFloat(strWeek),
            "cmMin": parseFloat(strMinCap),
            "cmMax": parseFloat(strMaxCap),
            "strMenuCode": menuCode,
            "strLoggedLocation": LocationCode,
            "strLoggedCompany": LogCompanyCode,
            "strReason": Reason,
            "strCreateBy": LogUserType,
            "blAddNew": addNew
        }

        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        const result = await SaveInboundCapacityDetails(InboundCapacity);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage('success', result.data)
            ClearItem()

        }
        else {
            displayAlertMessage('danger', result.data)
            setCodeButton(false)
        }

    }

    //***save/update end */


    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetStrDepartment(row.GP_CODE);
        getDepartmentData(row.GP_CODE)
        setmodal_xlarge(!modal_xlarge);
    }


    const GetSelectCodeRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.CM_CODE);
        getData(row.CM_CODE)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setcode_modal_xlarge(!code_modal_xlarge)
        setCrEnable(true)
    }

    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")


        SetStrDepartment("")
        SetDepartmentName("")
        SetStrYear("")
        SetStrWeek("")
        SetStrMinCap("")
        SetStrMaxCap("")

        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        setReason("Created")
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setExcelItems([])
        setTimeout(() => {
            setExcelItems([])
        }, 1)
    }

    //********Delete button function */

    const handleDelete = async () => {


        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": code,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeleteInboundCapacityDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage('success', result.data)
            ClearItem()
        }
        else {
            displayAlertMessage('warning', result.data)
        }
    }

    //*********Delete button function end */

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs() //clear username & password

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Oops something went wrong !")
            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "You have not Permission to make changes !")
            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Password or User Name is Invalid !")
            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //Function for displaying Alert Messages.S
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    function isLeapYear(year) {
        if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
            return true;
        } else {
            return false;
        }
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs() //clear password and username
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        // editEnable={editEnable && isHeadOffice}
                                        editEnable={editEnable}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)

                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        //deleteEnable={deleteEnable}
                                        deleteEnable={false}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)

                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <InboundCapacityContent

                                            GetSelectRow={GetSelectRow}
                                            GetSelectCodeRow={GetSelectCodeRow}
                                            show={show}
                                            AlertMsg={AlertMsg}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            codeModelTrigger={code_tog_xlarge}
                                            codeModelOpen={code_modal_xlarge}


                                            menuCode={menuCode}
                                            menuName={menuName}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            code={code}
                                            codeOnChange={e => {
                                                let val2 = Text(e.target, 10, true, false, "any", true)
                                                SetCode(val2)
                                            }}
                                            codeOnBlur={e => {

                                                getData(e.target.value)
                                            }}


                                            DepValue={strDepartment}
                                            DepOnChange={e => {
                                                let val2 = Numeric(
                                                    e.target,
                                                    3,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetStrDepartment(val2)

                                            }}
                                            departmentName={departmentName}
                                            YearValue={strYear}
                                            YearOnChange={e => {
                                                let numerval = Numeric(e.target, 4, false, false);
                                                SetStrYear(Math.max(0, numerval));

                                                // Reset week value when the year changes
                                                SetStrWeek("");
                                            }}

                                            YearOnBlur={e => {
                                                const yearRegex = /^(19|20)\d{2}$/;
                                                const isValidYear = yearRegex.test(parseFloat(e.target.value));

                                                if (!isValidYear) {
                                                    SetStrYear("");
                                                } else {
                                                    SetStrYear(strYear);
                                                }
                                            }}

                                            WeekValue={strWeek}
                                            WeekOnChange={e => {
                                                let numerval = Numeric(e.target, 4, false, false);
                                                SetStrWeek(Math.max(0, numerval));
                                            }}

                                            WeekOnBlur={e => {
                                                const weekRegex = /^(0?[1-9]|[1-4]\d|5[0-3])$/; // Regex for week (01-53)
                                                const isValidWeek = weekRegex.test(parseFloat(e.target.value));

                                                // Check if year is selected
                                                const selectedYear = parseInt(strYear);
                                                const isYearSelected = selectedYear > 0;

                                                if (!isValidWeek || !isYearSelected) {
                                                    // If week is not valid or year is not selected, set week to 0
                                                    SetStrWeek("");
                                                } else {
                                                    // If year is selected, calculate maximum valid week number
                                                    const maxWeekNumber = isLeapYear(selectedYear) ? 53 : 52;

                                                    // Ensure week number doesn't exceed the maximum valid week for the selected year
                                                    const weekNumber = parseInt(e.target.value);
                                                    const validWeekNumber = Math.min(weekNumber, maxWeekNumber);

                                                    SetStrWeek(validWeekNumber);
                                                }
                                            }}


                                            MinCapValue={strMinCap}
                                            MinCapOnChange={e => {
                                                let numerval = Numeric(e.target, 5, false, false);
                                                SetStrMinCap(Math.max(0, numerval));
                                            }}
                                            MinCapOnBlur={e => {
                                                const currentVal = parseFloat(e.target.value);
                                                if (e.target.value === "") {
                                                    SetStrMaxCap("");
                                                    SetStrMinCap("");
                                                } else {
                                                    const newMinCap = Math.max(0, currentVal);
                                                    SetStrMinCap(newMinCap);
                                                    if (newMinCap > parseFloat(strMaxCap)) {
                                                        SetStrMaxCap(newMinCap);
                                                    }
                                                }
                                            }}

                                            MaxCapValue={strMaxCap}
                                            MaxCapOnChange={e => {
                                                let numerval = Numeric(e.target, 5, false, false)
                                                SetStrMaxCap(numerval)
                                            }}
                                            MaxCapOnBlur={(e) => {
                                                const currentVal = parseFloat(e.target.value)
                                                if (e.target.value == "") {
                                                    SetStrMaxCap("")
                                                    SetStrMinCap("")
                                                }
                                                else {
                                                    if (parseFloat(currentVal) < parseFloat(strMinCap)) {
                                                        SetStrMaxCap("")
                                                        SetStrMinCap("")
                                                    }
                                                }
                                            }}

                                            DepOnBlur={e => {
                                                getDepartmentData(e.target.value)
                                            }}
                                            autoCode={autoCode}
                                        />
                                    </Row>

                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default InboundCapacityMaster